import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CommentList from '../CommentList';
import { CommentFooter } from '../commonComponents';

interface CommentsModalProps {
    isOpen: boolean;
    toggle: () => void;
    entityType: string;
    entityId: string;
    newComment: any; // Replace with the appropriate type
    updatedCommentsList: any[]; // Replace with the appropriate type
    onDeleteComment?: (commentId: string) => void; // Replace with the appropriate type
    handleAddComment: (comment: any) => void; // Replace with the appropriate type
    canLikeComment: boolean;
    fromPostDetail?: boolean;
}

const CommentsModal: React.FC<CommentsModalProps> = ({
    isOpen,
    toggle,
    entityType,
    entityId,
    newComment,
    updatedCommentsList,
    onDeleteComment,
    handleAddComment,
    canLikeComment
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            backdrop={true} 
            scrollable={true}
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader toggle={toggle}>Comments</ModalHeader>
            <ModalBody className="comment-like-modal-body">
                <CommentList
                    entityId={entityId}
                    entityType={entityType}
                    newComment={newComment}
                    updatedComments={updatedCommentsList}
                    onDeleteComment={onDeleteComment}
                />
            </ModalBody>
            <ModalFooter className='border-top border-gray-700 justify-content-start'>
                <CommentFooter
                    entityId={entityId}
                    entityType={entityType}
                    onAddComment={handleAddComment}
                    canLikeComment={canLikeComment}
                />
            </ModalFooter>
        </Modal>
    );
};

export default CommentsModal;